module.exports = __webpack_public_path__ + "media/src/public/images/mail/plain/brand-865da201b38a2568da7074922787e8fd.png";